// Static spreads (web/_spread.html: example pages, So geht's) look exactly like the book page and the
// reader: the same .bk-* markup, and the same fitText from bookpages.js shrinks a long text until it fits
// its page (desktop; on phones the text page grows instead, as on the book page). Refit on resize.
const {fitText} = require('./bookpages');

(function () {
  const groups = document.querySelectorAll('[data-static-spreads]');
  if (!groups.length) return;
  const fit = (force) => groups.forEach(g => fitText(g, g.dataset.font || '', g.dataset.textSize || '', force));
  const run = () => (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(() => fit(true));
  if (document.readyState === 'complete') run(); else window.addEventListener('load', run);
  let timer;
  window.addEventListener('resize', () => { clearTimeout(timer); timer = setTimeout(() => fit(true), 150); });
})();
